import React from 'react';
import PropTypes from 'prop-types';
import Box from 'reusecore/src/elements/Box';
import Text from 'reusecore/src/elements/Text';
import Heading from 'reusecore/src/elements/Heading';
import Button from 'reusecore/src/elements/Button';
import Image from 'reusecore/src/elements/Image';
import Container from 'common/src/components/UI/Container';

import PartnerSectionWrapper from './partner.style';
import Partner from 'common/src/assets/image/saasModern/Company-Logos.png';
// import Kongregate from 'common/src/assets/image/saasModern/CompanyLogos/Kongregate.png';
// import NBCUniversal from 'common/src/assets/image/saasModern/CompanyLogos/NBCUniversal.png';
// import Rogue from 'common/src/assets/image/saasModern/CompanyLogos/Rogue.png';
// import ThisGameStudio from 'common/src/assets/image/saasModern/CompanyLogos/ThisGameStudio.png';
import Fade from 'react-reveal/Fade';

const PartnerSection = ({
  row,
  col,
  title,
  description,
  button,
  textArea,
  imageArea,
}) => {
  return (
    <PartnerSectionWrapper>
      <Container>
        <Box {...row}>
          <Box {...col} {...imageArea}>
            <Fade up>
              <Image src={Partner} alt="Domain Image" />
            </Fade>
          </Box>

          <Box {...col} {...textArea}>
            <Fade up>
              <Heading
                {...title}
                content="Fizz powers chat for the world’s most innovative companies"
              />
            </Fade>
            <Fade up>
              <Text
                {...description}
                content="Companies that have some of the most robust scale and feature requirements in the gaming and app space trust Fizz to power their chat."
              />

            </Fade>
            {/* <Box>
              <a href="/features">
                <Button {...button} style={{ fontWeight: '700' }} title="LEARN MORE" />
              </a>
            </Box> */}
          </Box>
        </Box>
      </Container>
    </PartnerSectionWrapper>
  );
};

PartnerSection.propTypes = {
  row: PropTypes.object,
  col: PropTypes.object,
  title: PropTypes.object,
  description: PropTypes.object,
  button: PropTypes.object,
  textArea: PropTypes.object,
  imageArea: PropTypes.object,
};

PartnerSection.defaultProps = {
  row: {
    flexBox: true,
    flexWrap: 'wrap',
    ml: '-15px',
    mr: '-15px',
    alignItems: 'center',
  },
  imageAreaRow: {
    flexDirection: 'row-reverse',
  },
  col: {
    pr: '15px',
    pl: '15px',
  },
  textArea: {
    width: ['100%', '100%', '55%', '50%', '42%'],
  },
  imageArea: {
    width: ['100%', '100%', '45%', '50%', '58%'],
    mb: ['40px', '40px', '0', '0', '0'],
    // flex: true,
    // flexDirection: 'column',
    // justifyContent: 'center',
    // alignItems: 'center'
  },
  title: {
    fontSize: ['26px', '30px', '30px', '45px', '45px'],
    fontWeight: '400',
    color: '#0f2137',
    letterSpacing: '-0.025em',
    mb: '15px',
    lineHeight: '1.25',
  },
  description: {
    fontSize: '16px',
    color: '#343d48cc',
    lineHeight: '1.75',
    mb: '33px',
  },
  button: {
    type: 'button',
    fontSize: '14px',
    fontWeight: '700',
    borderRadius: '4px',
    pl: '22px',
    pr: '22px',
    colors: 'secondaryWithBg',
    minWidth: '150px',
  },
};

export default PartnerSection;
